<div class="modal-body text-center">
    <div class="d-flex align-items-center">
        <strong>Please Wait...</strong>
        <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
    </div>
</div>